import { StylesDerivedNativeActions } from '@wix/editor-platform-host-integration-apis';
import createDefaultActionDefinition from '../common/actionDefinition/default';
import { createBorderValidator } from './validator';

export { parseBorderValue } from './parser';

const borderAction = {
  ...createDefaultActionDefinition(StylesDerivedNativeActions.borderStyles),
  validator: createBorderValidator(),
};
export default borderAction;
